/**
 * Dustrato Kinetic System - theme.js
 * Shopify AJAX cart, quantity, variant sync - Stitch-compatible
 */
document.addEventListener('DOMContentLoaded', () => {
  // Quantity input delegation for cart
  document.addEventListener('click', async (e) => {
    const minus = e.target.closest('button[name="minus"]');
    const plus = e.target.closest('button[name="plus"]');
    if (!minus && !plus) return;

    const input = e.target.closest('quantity-input')?.querySelector('input') || e.target.closest('.flex')?.querySelector('input[name="updates[]"]');
    if (!input) return;

    const current = parseInt(input.value || '1', 10);
    const next = minus ? Math.max(0, current - 1) : current + 1;
    input.value = next;

    // Auto-submit cart change via fetch
    const index = input.dataset.index;
    if (index) {
      try {
        const res = await fetch(`${window.routes.cart_change_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: parseInt(index, 10), quantity: next })
        });
        const data = await res.json();
        if (data.item_count !== undefined) {
          window.location.reload();
        }
      } catch (err) {
        window.location.reload();
      }
    }
  });

  // Add to cart intercept for product cards (enhance with fetch, fallback to form post)
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      const submitter = e.submitter;
      if (submitter && submitter.name === 'buy_now') return; // let buy now redirect

      // Optional: AJAX add without leaving page (comment out to keep traditional POST)
      // e.preventDefault();
      // const formData = new FormData(form);
      // await fetch(window.routes.cart_add_url, { method: 'POST', body: formData });
      // window.location.href = window.routes.cart_url;
    });
  });

  // Thumbnail gallery switch on PDP
  document.querySelectorAll('[data-media-id]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const main = document.getElementById('MainProductImage');
      const img = btn.querySelector('img');
      if (main && img) {
        const src = img.getAttribute('src') || img.currentSrc;
        if (src) main.src = src.replace(/width=\d+/, 'width=1200');
        document.querySelectorAll('[data-media-id]').forEach(b => {
          b.className = 'w-24 h-24 md:w-32 md:h-32 flex-shrink-0 border border-outline hover:border-primary opacity-70 hover:opacity-100 snap-start focus:outline-none focus:ring-2 focus:ring-secondary-container transition-all';
        });
        btn.className = 'w-24 h-24 md:w-32 md:h-32 flex-shrink-0 border-2 border-primary snap-start focus:outline-none focus:ring-2 focus:ring-secondary-container transition-all';
      }
    });
  });
});

// Shopify common helpers
window.onCartRefresh = () => window.location.reload();

// Homepage quick-add: AJAX-add the tapped size, then land on the cart page.
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  const id = btn.dataset.variantId;
  if (!id) {
    const fallback = btn.closest('article')?.querySelector('h3 a')?.href;
    window.location.href = fallback || window.routes.cart_url;
    return;
  }
  btn.disabled = true;
  try {
    await fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    });
  } catch (err) {}
  btn.disabled = false;
  if (window.DustratoCart && window.DustratoCart.afterAdd) { window.DustratoCart.afterAdd(); }
  else { window.location.href = window.routes.cart_url; }
});

// Cart drawer: slides in after add-to-cart, no page load.
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setOpen(open, instant) {
    var el = document.getElementById('CartDrawer');
    if (!el) return;
    var p = el.querySelector('[data-cart-panel]');
    var b = el.querySelector('[data-cart-backdrop]');
    el.dataset.state = open ? 'open' : 'closed';
    if (open) {
      el.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      var apply = function () {
        if (p) p.classList.remove('translate-x-full');
        if (b) b.classList.add('opacity-100');
      };
      if (instant) { apply(); } else { requestAnimationFrame(apply); }
    } else {
      if (p) p.classList.add('translate-x-full');
      if (b) b.classList.remove('opacity-100');
      document.body.style.overflow = '';
      setTimeout(function () { if (el.dataset.state === 'closed') el.classList.add('hidden'); }, 320);
    }
  }

  function updateCount(n) {
    document.querySelectorAll('[data-cart-count-bubble]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('hidden', !n);
    });
  }

  function refresh(cb) {
    fetch(root + '?section_id=cart-drawer&t=' + Date.now(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawer');
        var current = document.getElementById('CartDrawer');
        if (fresh && current) { current.replaceWith(document.importNode(fresh, true)); }
        if (cb) cb();
      })
      .catch(function () { if (cb) cb(); });
  }

  function afterAdd() {
    fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { updateCount(data.item_count); })
      .catch(function () {});
    refresh(function () { setOpen(true); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      refresh(function () { setOpen(true); });
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      setOpen(false);
      return;
    }
    var minus = e.target.closest('[data-drawer-minus]');
    var plus = e.target.closest('[data-drawer-plus]');
    var rem = e.target.closest('[data-drawer-remove]');
    if (!minus && !plus && !rem) return;
    e.preventDefault();
    var line = parseInt((minus || plus || rem).dataset.line, 10);
    var row = document.querySelector('[data-drawer-line="' + line + '"]');
    var q = row ? parseInt(row.dataset.qty || '1', 10) : 1;
    var next = rem ? 0 : (minus ? Math.max(0, q - 1) : q + 1);
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: next })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.item_count !== undefined) updateCount(data.item_count);
        refresh(function () { setOpen(true, true); });
      })
      .catch(function () {});
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var el = document.getElementById('CartDrawer');
      if (el && el.dataset.state === 'open') setOpen(false);
    }
  });

  window.DustratoCart = {
    open: function () { refresh(function () { setOpen(true); }); },
    close: function () { setOpen(false); },
    afterAdd: afterAdd,
    refresh: refresh
  };
})();

// Touch devices: one tap goes straight to the product. The click is fired
// from touchend so iOS's sticky-hover never eats the first tap. While the
// finger is down - including during a scroll - the card peeks its hover image.
document.addEventListener('touchstart', function (e) {
  if (e.touches.length > 1) return;
  var card = e.target.closest('article.group');
  if (!card) return;
  var link = e.target.closest('a[href]');
  var href = link ? link.getAttribute('href') : null;
  if (card.querySelector('.card-img-hover')) card.classList.add('touched');

  var startX = e.touches[0].clientX;
  var startY = e.touches[0].clientY;
  var moved = false;

  function onMove(ev) {
    var t = ev.touches[0];
    if (!t) return;
    if (Math.abs(t.clientX - startX) > 8 || Math.abs(t.clientY - startY) > 8) moved = true;
  }
  function cleanup() {
    card.classList.remove('touched');
    card.removeEventListener('touchmove', onMove);
    card.removeEventListener('touchend', onEnd);
    card.removeEventListener('touchcancel', onCancel);
  }
  function onEnd(ev) {
    var go = !moved && href && href !== '#';
    cleanup();
    if (go) {
      if (ev.cancelable) ev.preventDefault();
      window.location.href = href;
    }
  }
  function onCancel() { cleanup(); }

  card.addEventListener('touchmove', onMove, { passive: true });
  card.addEventListener('touchend', onEnd);
  card.addEventListener('touchcancel', onCancel);
}, { passive: true });

/* Dustrato v3 motion: scroll reveals, 3D tilt, hero parallax */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('in'); });
    return;
  }

  // Stagger reveals inside grouped sections
  document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
    group.querySelectorAll('[data-reveal]').forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i * 90, 540) + 'ms';
    });
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });

  // 3D tilt on imagery (fine pointers only)
  if (window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('[data-tilt]').forEach(function (card) {
      var raf = null;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.transform = 'perspective(900px) rotateX(' + (-y * 7).toFixed(2) + 'deg) rotateY(' + (x * 9).toFixed(2) + 'deg)';
        });
      });
      card.addEventListener('mouseleave', function () {
        cancelAnimationFrame(raf);
        card.style.transform = '';
      });
    });
  }

  // Hero video parallax + content drift
  var heroVideo = document.querySelector('.hero-transparent video');
  var heroContent = document.querySelector('.hero-transparent .relative.z-10');
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking || (!heroVideo && !heroContent)) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      var vh = window.innerHeight;
      if (y < vh * 1.2) {
        if (heroVideo) heroVideo.style.transform = 'translateY(' + (y * 0.22) + 'px) scale(1.1)';
        if (heroContent) {
          heroContent.style.transform = 'translateY(' + (y * 0.12) + 'px)';
          heroContent.style.opacity = Math.max(0, 1 - y / (vh * 0.85));
        }
      }
      ticking = false;
    });
  }, { passive: true });
})();
